'use client';

import React, { useState } from 'react';
import MobileNavbar from './MobileNavbar';
import RadialMenu from './RadialMenu';

export default function BottomNavigation() {
  const [active, setActive] = useState(2);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <RadialMenu open={menuOpen} setOpen={setMenuOpen} />

      <MobileNavbar
        menuOpen={menuOpen}
        active={active}
        setActive={setActive}
        onMenuClick={() => setMenuOpen((prev) => !prev)}
      />
    </>
  );
}
